import _classCallCheck from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _createClass from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _inherits from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import React from 'react';
import ReactDOM from 'react-dom';

var ContainerDimension =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(ContainerDimension, _React$PureComponent);

  _createClass(ContainerDimension, null, [{
    key: "getDomNodeDimensions",
    value: function getDomNodeDimensions(node) {
      return node.getBoundingClientRect();
    }
  }]);

  function ContainerDimension(props) {
    var _this;

    _classCallCheck(this, ContainerDimension);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ContainerDimension).call(this, props));
    _this.state = {
      initiated: false,
      width: null
    };
    return _this;
  }

  _createClass(ContainerDimension, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.parentNode = ReactDOM.findDOMNode(this).parentNode;
      this.componentIsMounted = true;
      this.onResize();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.width !== prevProps.width) this.onResize();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.componentIsMounted = false;
    }
  }, {
    key: "onResize",
    value: function onResize() {
      var clientRect = ContainerDimension.getDomNodeDimensions(this.parentNode);

      if (this.componentIsMounted) {
        this.setState({
          initiated: true,
          width: clientRect.width
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (typeof this.props.children === 'function') {
        var renderedChildren = this.props.children(this.state.width);
        return renderedChildren;
      }
    }
  }]);

  return ContainerDimension;
}(React.PureComponent);

export { ContainerDimension as default };